import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import IncumplimientoForm from '../Forms/IncumplimientoForm';

const AddEditIncumplimiento = ({
	dataIncumplimiento,
	dataFiscalizacion,
	isOpen,
	handleToggleModal,
	initialFormValues,
	onFormValuesChange,
	onRequestCreateResponsible,
	handleSave,
	isEdit,
	tipoFiscalizacion,
	isEnRevision,
	inspectionTypeOptions,
	inspectionAuthorityOptions,
	responsibleOptions,
	breachResponsibleAreaOptions,
	breachImpactOptions,
	breachOriginOptions,
	breachTypeOfEvidenceOptions,
	breachCategoryOptions,
	breachRiskClassificationOptions,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			backdrop='static'
			centered={true}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
		>
			<ModalHeader className='p-3 ' toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Incumplimiento
			</ModalHeader>
			<IncumplimientoForm
				dataIncumplimiento={dataIncumplimiento}
				dataFiscalizacion={dataFiscalizacion}
				handleToggleModal={handleToggleModal}
				initialFormValues={initialFormValues}
				onFormValuesChange={onFormValuesChange}
				onRequestCreateResponsible={onRequestCreateResponsible}
				isEdit={isEdit}
				handleSave={handleSave}
				tipoFiscalizacion={tipoFiscalizacion}
				isEnRevision={isEnRevision}
				inspectionTypeOptions={inspectionTypeOptions}
				inspectionAuthorityOptions={inspectionAuthorityOptions}
				responsibleOptions={responsibleOptions}
				breachResponsibleAreaOptions={breachResponsibleAreaOptions}
				breachImpactOptions={breachImpactOptions}
				breachOriginOptions={breachOriginOptions}
				breachTypeOfEvidenceOptions={breachTypeOfEvidenceOptions}
				breachCategoryOptions={breachCategoryOptions}
				breachRiskClassificationOptions={breachRiskClassificationOptions}
			/>
		</Modal>
	);
};

export default AddEditIncumplimiento;
